import httpStore from "@/api/httpStore.js";

// Quotes have their own tables but open in BaseOrderModal and are edited with
// the order endpoints: their orderNumber is negative (-quote number) and the
// API sends those requests to the quote tables. These calls cover what is
// specific to them: list, create, rename, convert and delete.

export function getQuotes({
  page = 1,
  limitPerPage = 50,
  search = "",
  status = "open",
  showAll = false,
  customerInfoautoId = "",
  customerEmail = ""
} = {}) {
  return httpStore
    .get(`/quotes/list`, {
      params: {
        page,
        limitPerPage,
        search,
        status,
        showAll,
        customerInfoautoId,
        customerEmail
      }
    })
    .then(res => res.data);
}

// customerInfoautoId attaches an infoauto customer, customerEmail a web one
export function createQuote({
  customerInfoautoId = null,
  customerEmail = null,
  name = ""
} = {}) {
  return httpStore
    .post(`/quotes/create`, {
      customer_infoauto_id: customerInfoautoId,
      customer_email: customerEmail,
      name
    })
    .then(res => res.data);
}

export function updateQuoteName(orderNumber, name) {
  return httpStore
    .post(`/quotes/update/${orderNumber}`, { name })
    .then(res => res.data);
}

// Ready: the customer can pay it from the store, with its prices for a few
// days from now (settings.quote_price_valid_days). Returns { readyAt, pricesValidUntil }
export function markQuoteReady(orderNumber, ready = true) {
  return httpStore
    .post(`/quotes/ready/${orderNumber}`, { ready })
    .then(res => res.data);
}

export function convertQuoteToOrder(orderNumber) {
  return httpStore.post(`/quotes/convert/${orderNumber}`).then(res => res.data);
}

export function deleteQuote(orderNumber) {
  return httpStore
    .delete(`/quotes/single/${orderNumber}`)
    .then(res => res.data);
}

export function isQuoteNumber(orderNumber) {
  return Number(orderNumber) < 0;
}

// Reference shown for an order or quote: Q-200000012 / #200000012
export function quoteReference(orderNumber) {
  if (isQuoteNumber(orderNumber)) {
    return `Q-${-Number(orderNumber)}`;
  }
  return `#${orderNumber}`;
}
